module.exports = __webpack_public_path__ + "static/media/Group.898e1ce5.svg";